module.exports = __webpack_public_path__ + "img/Share.095d115b.svg";